// extracted by mini-css-extract-plugin
export default {"titleHeader":"StudyCode_titleHeader__sT+vE"};